import React from 'react';
import { Instagram, Facebook, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-apex-charcoal text-white pt-20 pb-10" data-id="element-61">
      <div className="container mx-auto px-4 md:px-6" data-id="element-62">
        {/* Top 4 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16 text-center md:text-left" data-id="element-63">
          {/* Col 1: Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-64">
            <a href="#home" className="flex items-center gap-2 mb-6" data-id="element-65">
              <div className="w-8 h-8 bg-apex-green rounded-sm flex items-center justify-center" data-id="element-66">
                <span className="text-white font-extrabold text-xl leading-none tracking-tighter" data-id="element-67">
                  A
                </span>
              </div>
              <span className="font-extrabold text-xl tracking-tight text-white" data-id="element-68">
                APEX
              </span>
            </a>
            <p className="text-gray-400 mb-8 font-medium" data-id="element-69">
              Listing-ready exteriors. Built for Realtors.
            </p>
            <div className="flex gap-4" data-id="element-70">
              <a href="#" className="w-10 h-10 rounded-full bg-apex-green flex items-center justify-center hover:bg-green-600 transition-colors" data-id="element-71">
                <Instagram className="w-5 h-5 text-white" data-id="element-72" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-apex-green flex items-center justify-center hover:bg-green-600 transition-colors" data-id="element-73">
                <Facebook className="w-5 h-5 text-white" data-id="element-74" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-apex-green flex items-center justify-center hover:bg-green-600 transition-colors" data-id="element-75">
                <Linkedin className="w-5 h-5 text-white" data-id="element-76" />
              </a>
            </div>
          </div>

          {/* Col 2: Services */}
          <div data-id="element-77">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-78">Services</h4>
            <ul className="space-y-4" data-id="element-79">
              <li data-id="element-80">
                <a href="#" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-81">
                  Yard Cleanup & Refresh
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-83">
                  Exterior Pressure Washing
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-85">
                  Debris & Junk Removal
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-87">
                  Window & Screen Cleaning
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-89">
                  Light Landscaping
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3: Company */}
          <div data-id="element-90">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-91">Company</h4>
            <ul className="space-y-4" data-id="element-92">
              <li data-id="element-93">
                <a href="#about" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-94">
                  About
                </a>
              </li>
              <li data-id="element-95">
                <a href="#how-it-works" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-96">
                  How It Works
                </a>
              </li>
              <li data-id="element-97">
                <a href="#service-area" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-98">
                  Service Area
                </a>
              </li>
              <li data-id="element-99">
                <a href="#contact" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-100">
                  Contact
                </a>
              </li>
              <li data-id="element-101">
                <a href="#partner" className="text-gray-400 hover:text-apex-green transition-colors" data-id="element-102">
                  Become A Partner
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div data-id="element-103">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-104">Get In Touch</h4>
            <ul className="space-y-4 text-gray-400" data-id="element-105">
              <li data-id="element-106">
                <a href="tel:+15555555555" className="hover:text-apex-green transition-colors font-medium text-white" data-id="element-107">
                  (555) 555-5555
                </a>
              </li>
              <li data-id="element-108">
                <a href="mailto:hello@apexcurbside.com" className="hover:text-apex-green transition-colors" data-id="element-109">
                  hello@apexcurbside.com
                </a>
              </li>
              <li className="pt-2" data-id="element-110">
                Serving the greater Phoenix, AZ metropolitan area.
              </li>
              <li className="pt-2 text-sm" data-id="element-111">
                Mon-Sat: 7am - 6pm
                <br data-id="element-112" />
                Sun: Closed
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-113">
          <p data-id="element-114">© 2026 Apex Curbside Appeal LLC. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-115">
            <a href="#" className="hover:text-white transition-colors" data-id="element-116">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-117">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}